import React from 'react';
import { useTranslation } from '@/contexts/LanguageContext';
import { Slide, FontStyle } from '@/types';
import RichTextEditor from '@/components/RichTextEditor';

interface TextEditorPanelProps {
  activeSlide: Slide;
  activeIndex: number;
  slides: Slide[];
  onUpdateSlides: (slides: Slide[]) => void;
  onTextChange: (text: string) => void;
}

const TextEditorPanel: React.FC<TextEditorPanelProps> = ({
  activeSlide,
  activeIndex,
  slides,
  onUpdateSlides,
  onTextChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-3 space-y-4">
      <div data-tour="mobile-text-editor">
        <h3 className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-2">{t('workspace.editSlide')}</h3>
        <RichTextEditor
          content={activeSlide.content}
          onChange={onTextChange}
          placeholder={t('editor.richText.placeholder')}
          fontFamily={activeSlide.fontStyle || 'GLOBAL'}
          onFontFamilyChange={(value) => {
            const newSlides = [...slides];
            newSlides[activeIndex] = { ...activeSlide, fontStyle: value === 'GLOBAL' ? undefined : value as FontStyle };
            onUpdateSlides(newSlides);
          }}
          fontScale={activeSlide.fontScale ?? 1.0}
          onFontScaleChange={(scale) => {
            const newSlides = [...slides];
            newSlides[activeIndex] = { ...activeSlide, fontScale: scale === 1.0 ? undefined : scale };
            onUpdateSlides(newSlides);
          }}
        />
      </div>
    </div>
  );
};

export default TextEditorPanel;
